import { db } from '../../../config/firebaseConfig';
import {
  doc,
  setDoc,
  collection,
  getDocs,
  deleteDoc,
} from 'firebase/firestore';

const sanitizeForId = (value = '') => value.toLowerCase().replace(/[^a-z0-9]+/g, '_').replace(/^_+|_+$/g, '');

const buildJobId = (job = {}) => {
  const source = job.uri || job.code || job.id || job.title || `job_${Date.now()}`;
  const sanitized = sanitizeForId(source);
  return sanitized || `job_${Date.now()}`;
};

export const saveJob = async (userId, jobData) => {
  if (!userId) {
    throw new Error('Missing userId while saving job.');
  }

  const jobId = buildJobId(jobData);
  const jobRef = doc(db, 'users', userId, 'jobs', jobId);

  await setDoc(jobRef, {
    ...jobData,
    id: jobId,
    updatedAt: new Date(),
    createdAt: jobData?.createdAt || new Date(),
  }, { merge: true });

  return {
    success: true,
    id: jobId,
  };
};

export const loadUserJobs = async (userId) => {
  if (!userId) {
    return [];
  }

  const jobsRef = collection(db, 'users', userId, 'jobs');
  const snapshot = await getDocs(jobsRef);
  const jobs = [];

  snapshot.forEach((item) => {
    jobs.push({
      ...item.data(),
      id: item.id,
    });
  });

  jobs.sort((a, b) => {
    const aDate = a.updatedAt?.toDate?.() || new Date(a.updatedAt || 0);
    const bDate = b.updatedAt?.toDate?.() || new Date(b.updatedAt || 0);
    return bDate - aDate;
  });

  return jobs;
};

export const deleteJob = async (userId, jobId) => {
  if (!userId || !jobId) {
    throw new Error('Missing userId or jobId while deleting job.');
  }

  const jobRef = doc(db, 'users', userId, 'jobs', jobId);
  await deleteDoc(jobRef);

  return {
    success: true,
  };
};
